module.exports = {"411626001":"柳湖街道","411626100":"城关回族镇","411626101":"新站镇","411626102":"鲁台镇","411626103":"四通镇","411626104":"临蔡镇","411626105":"安岭镇","411626106":"白楼镇","411626200":"朱集乡","411626201":"豆门乡","411626202":"冯塘乡","411626203":"刘振屯乡","411626204":"王店乡","411626205":"大连乡","411626206":"葛店乡","411626207":"黄集乡","411626209":"齐老乡","411626210":"郑集乡","411626211":"曹河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411626.json
// module id = 1681
// module chunks = 0